/**
 * 装配体配合对象元数据读取适配器。
 *
 * 文件职责：
 * 1. 保持 Mate 模块既有导入路径稳定；
 * 2. 将 assemblyNodeId 解析统一委托给 component-instance 边界；
 * 3. 禁止在 Mate 模块内重复理解 imported-model 的 metadata / userData 结构。
 */

import type { Object3D } from 'three/webgpu';
import { readComponentInstanceAssemblyNodeId } from '../../component-instance';

/**
 * 读取对象对应的装配实例节点 ID。
 *
 * @param object 场景对象。
 * @returns 装配实例节点 ID；缺失时返回空字符串。
 */
export function readAssemblyMateObjectAssemblyNodeId(object: Object3D): string {
  return readComponentInstanceAssemblyNodeId(object);
}
